import AclName from '../AclName.js';

export default [
  // AclName.StaffBtnAgreementsAdd,
  // AclName.StaffBtnAgreementsAddTerminationDate,
  // AclName.StaffBtnAgreementsDeductionsAdd,
  // AclName.StaffBtnAgreementsDelete,
  // AclName.StaffBtnAgreementsEdit,
  // AclName.StaffBtnAgreementsGenerateBill,
  // AclName.StaffBtnAgreementsGenerateIndividualPayment,
  // AclName.StaffBtnBillsDelete,
  // AclName.StaffBtnBillsEdit,
  // AclName.StaffBtnBillsGenerateBills,
  // AclName.StaffBtnDeclarationsPitAdd,
  // AclName.StaffBtnDeclarationsPitDelete,
  // AclName.StaffBtnDeclarationsPitRefresh,
  // AclName.StaffBtnDeductionsDelete,
  // AclName.StaffBtnDeductionsEdit,
  // AclName.StaffBtnEmployeeAdd,
  // AclName.StaffBtnEmployeeDelete,
  // AclName.StaffBtnEmployeeEdit,
  // AclName.StaffBtnPaymentDelete,
  // AclName.StaffBtnPaymentEdit,
  // AclName.StaffBtnPaymentRecalculate,
  // AclName.StaffBtnPayrollDelete,
  // AclName.StaffBtnPayrollGeneratePayroll,
  // AclName.StaffFormAgreementsEditable,
  // AclName.StaffFormBillsEditable,
  // AclName.StaffFormDeductionsEditable,
  // AclName.StaffFormEmployeeEditable,
  // AclName.StaffFormPaymentEditable,
  AclName.StaffAccessAll,
  AclName.StaffBtnAgreementsDeductions,
  AclName.StaffBtnAgreementsPreview,
  AclName.StaffBtnAgreementsPrintAgreement,
  AclName.StaffBtnBillsPreview,
  AclName.StaffBtnBillsPrintAllBills,
  AclName.StaffBtnBillsPrintBill,
  AclName.StaffBtnDeclarationsPitPrint,
  AclName.StaffBtnDeclarationsPitPrintUPO,
  AclName.StaffBtnDeductionsPreview,
  AclName.StaffBtnEmployeePreview,
  AclName.StaffBtnPaymentPreview,
  AclName.StaffBtnPaymentPrintPayment,
  AclName.StaffBtnPayrollEmployeesList,
  AclName.StaffBtnPayrollPrintPayroll,
  AclName.StaffPageAgreementsDeductionsEdit,
  AclName.StaffPageAgreementsDeductionsList,
  AclName.StaffPageAgreementsEdit,
  AclName.StaffPageAgreementsList,
  AclName.StaffPageBillsEdit,
  AclName.StaffPageBillsList,
  AclName.StaffPageDeclarationsPitList,
  AclName.StaffPageEmployeesEdit,
  AclName.StaffPageEmployeesList,
  AclName.StaffPageLeavesAdd,
  AclName.StaffPageLeavesEdit,
  AclName.StaffPageLeavesList,
  AclName.StaffPageAccidentInsurancesList,
  AclName.StaffPagePayrollEmployeesEdit,
  AclName.StaffPagePayrollEmployeesList,
  AclName.StaffPagePayrollList,
];
